import { on, TanokDispatcher, rethrowFx, filter } from 'tanok';
import imm from 'immutable';

import * as c from '../../libs/constants';
import * as a from '../../libs/actions';
import * as fx from '../../libs/effect';
import {
    requestClientInfo,
    requestCompanyInfo
} from '../../libs/transport';

export class BanDispatcher extends TanokDispatcher {
    @on(a.EVENT_BESIDA_SEND_BAN_LIST)
    besidaSendBanList(_, state) {
        return [state, fx.besidaSendBanListFx(state.get('besida'), state.get('prevOpenedRoomIdent'))];
    }

    @on(a.EVENT_BESIDA_SEND_UNBAN_LIST)
    besidaSendUnbanList(_, state) {
        return [state, fx.besidaSendUnbanListFx(state.get('besida'), state.get('prevOpenedRoomIdent'))];
    }

    @on(filter(({ action }) => [
        a.EVENT_BESIDA_SEND_UNBAN_LIST_SUCCESS,
        a.EVENT_BESIDA_SEND_BAN_LIST_SUCCESS
    ].includes(action)))
    besidaSendBanListSuccess(_, state) {
        let updState = state;

        updState = updState.set('clientInfo', imm.Map());
        updState = updState.set('companyInfo', imm.Map());

        updState = updState.set('activeClientTab', c.CHAT_CLIENT_INFO);
        updState = updState.set('activeCompanyTab', c.CHAT_COMPANY_INFO);

        updState = updState.set('prevOpenedRoomIdent', null);
        updState = updState.set('modifiedCompanyRoom', null);
        updState = updState.set('modifiedClientRoom', null);
        updState = updState.set('clientsUserId', null);
        updState = updState.set('companyBanId', null);
        updState = updState.setIn(['notification', 'error'], null);

        return [updState, rethrowFx(a.EVENT_OPEN_ROOM, state.get('prevOpenedRoomIdent'))];
    }

    //* Client ban actions

    @on(a.EVENT_CLIENT_SHOW_INFO)
    clientShowInfo({ ident }, state) {
        let updState = state;

        updState = updState.set('clientsUserId', ident);

        updState = updState.set('prevOpenedRoomIdent', state.get('openedRoomIdent'));

        updState = updState.set('currentRoomName', null);
        updState = updState.set('openedRoomIdent', null);
        updState = updState.set('stayInDialog', false);
        updState = updState.set('newMsgMarkShown', false);

        return [updState, rethrowFx(a.TR_GET_CLIENT_INFO, { ident })];
    }

    @on(a.TR_GET_CLIENT_INFO)
    getClientInfo({ ident }, state) {
        return [state.setIn(['isLoadingData', 'clientInfo'], true), requestClientInfo(ident)];
    }

    @on(a.TR_GET_CLIENT_INFO_SUCCESS)
    getClientInfoSuccess({ client }, state) {
        let updState = state;

        updState = state.setIn(['isLoadingData', 'clientInfo'], false);

        if (!client) {
            updState = updState.setIn(['clientInfo', 'notFound'], true);
            return [updState];
        }

        updState = updState.set('clientInfo', imm.fromJS(client));
        return [updState];
    }

    // improve we need mechanism to show short alerts in dialog window
    @on(a.TR_GET_CLIENT_INFO_FAIL)
    getClientInfoFail(_, state) {
        let updState = state;

        updState = state.setIn(['isLoadingData', 'clientInfo'], false);
        updState = state.setIn(['notification', 'error'], c.NOTIFICATION_ERROR_CLIENT_INFO);

        return [updState];
    }

    @on(a.EVENT_CLIENT_BACK_TAB)
    clientBackTab(_, state) {
        let updState = state;

        switch (state.get('activeClientTab')) {
            case c.CHAT_CLIENT_INFO:
                updState = updState.set('prevOpenedRoomIdent', null);
                updState = updState.set('clientsUserId', null);
                updState = updState.set('clientInfo', imm.Map());
                updState = updState.setIn(['notification', 'error'], null);
                return [updState, rethrowFx(a.EVENT_OPEN_ROOM, state.get('prevOpenedRoomIdent'))];
            case c.CHAT_CLIENT_BAN:
            case c.CHAT_CLIENT_UNBAN:
            default:
                updState = updState.set('activeClientTab', c.CHAT_CLIENT_INFO);
                return [updState];
        }
    }

    @on(a.EVENT_CLIENT_CHANGE_TAB)
    clientChangeTab({ tabName }, state) {
        return [state.set('activeClientTab', tabName)];
    }

    //* Company ban section

    @on(a.EVENT_COMPANY_SHOW_INFO)
    companyShowInfo({ ident }, state) {
        let updState = state;

        updState = updState.set('companyBanId', ident);

        updState = updState.set('prevOpenedRoomIdent', state.get('openedRoomIdent'));

        updState = updState.set('currentRoomName', null);
        updState = updState.set('openedRoomIdent', null);
        updState = updState.set('stayInDialog', false);
        updState = updState.set('newMsgMarkShown', false);

        return [updState, rethrowFx(a.TR_GET_COMPANY_INFO, { ident })];
    }

    @on(a.TR_GET_COMPANY_INFO)
    getCompanyInfo({ ident }, state) {
        return [state.setIn(['isLoadingData', 'companyInfo'], true), requestCompanyInfo(ident)];
    }

    @on(a.TR_GET_COMPANY_INFO_SUCCESS)
    getCompanyInfoSuccess({ company }, state) {
        let updState = state;

        updState = state.setIn(['isLoadingData', 'companyInfo'], false);
        updState = updState.set('companyInfo', imm.fromJS(company));

        return [updState];
    }

    @on(a.TR_GET_COMPANY_INFO_FAIL)
    getCompanyInfoFail(_, state) {
        let updState = state;

        updState = state.setIn(['isLoadingData', 'companyInfo'], false);
        updState = state.setIn(['notification', 'error'], c.NOTIFICATION_ERROR_COMPANY_INFO);
        return [updState];
    }

    @on(a.EVENT_COMPANY_BACK_TAB)
    companyBackTab(_, state) {
        let updState = state;

        switch (state.get('activeCompanyTab')) {
            case c.CHAT_COMPANY_INFO:
                updState = updState.set('prevOpenedRoomIdent', null);
                updState = updState.set('companyBanId', null);
                updState = updState.set('companyInfo', imm.Map());
                updState = updState.setIn(['notification', 'error'], null);
                return [updState, rethrowFx(a.EVENT_OPEN_ROOM, state.get('prevOpenedRoomIdent'))];
            case c.CHAT_COMPANY_BAN:
            case c.CHAT_COMPANY_UNBAN:
            default:
                updState = updState.set('activeCompanyTab', c.CHAT_COMPANY_INFO);
                return [updState];
        }
    }

    @on(a.EVENT_COMPANY_CHANGE_TAB)
    companyChangeTab({ tabName }, state) {
        return [state.set('activeCompanyTab', tabName)];
    }
}
